
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as zoekfQb_45CrymB_gFt1nQTg3U0YewhM9cFinDmPpMZfUKtRQMeta } from "/builds/allard-pierson/allard-pierson-frontend/pages/zoek.vue?macro=true";
import { default as indexzcAsOXX4TJjqC6bCcV_kTca_d6qTk7ybeXPTr_45SRw9wMeta } from "/builds/allard-pierson/allard-pierson-frontend/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93EKqGPIqPBGzPxiXeKQUFUtJ7CxIkJL4011lGJZAHhU8Meta } from "/builds/allard-pierson/allard-pierson-frontend/pages/[...slug].vue?macro=true";
import { default as indexsGvZnQTzt6YbukLBhRVp78H40HanwtcYC0mve6k9ndQMeta } from "/builds/allard-pierson/allard-pierson-frontend/pages/blog/index.vue?macro=true";
import { default as indexQH7vaNdypQz168AsRk_8ar0AKeP5Hr2pA4v0mpPlkGoMeta } from "/builds/allard-pierson/allard-pierson-frontend/pages/agenda/index.vue?macro=true";
import { default as indexwcc1abf31KmAMbzfwiDTkj52Z8w1GZGF2Xgs4IB3qPQMeta } from "/builds/allard-pierson/allard-pierson-frontend/pages/nieuws/index.vue?macro=true";
import { default as archiefc5JdXIPZZjOyRoZtplhQpp2q2gvycuysZTg_45dvpaIacMeta } from "/builds/allard-pierson/allard-pierson-frontend/pages/agenda/archief.vue?macro=true";
import { default as _91_46_46_46slug_93bvjjjxOdEVNCD8nxYiRaARtAhha0_45qX_453HbrbTFnWZYMeta } from "/builds/allard-pierson/allard-pierson-frontend/pages/blog/[...slug].vue?macro=true";
import { default as index8umNVvAGuKPQNRa24zLKWGj0JYdLUFx3LXOyepZLtEAMeta } from "/builds/allard-pierson/allard-pierson-frontend/pages/collectie/index.vue?macro=true";
import { default as _91_46_46_46slug_930grw9dUcTeoUjt_A2IwRK06qtPCweZcr8KdcXwCNI_QMeta } from "/builds/allard-pierson/allard-pierson-frontend/pages/agenda/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_934xV84NgUYmB4aLTYGXhwPUIMf01G1cfjvQXL4ycQGqoMeta } from "/builds/allard-pierson/allard-pierson-frontend/pages/nieuws/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93ShiQ9m8P_45kTX1oUkSe9pVxlP6cNBLj8_ivo425wQxIAMeta } from "/builds/allard-pierson/allard-pierson-frontend/pages/collectie/[...slug].vue?macro=true";
import { default as component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5EMeta } from "/builds/allard-pierson/allard-pierson-frontend/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@20.19.1_db0@0.3.2_eslint@8.57.1_ioredis@5.6.1_l_b3tldu2hg6idvfas24hkuih3nq/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5E } from "/builds/allard-pierson/allard-pierson-frontend/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@20.19.1_db0@0.3.2_eslint@8.57.1_ioredis@5.6.1_l_b3tldu2hg6idvfas24hkuih3nq/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "zoek___nl",
    path: "/zoek",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/zoek.vue")
  },
  {
    name: "zoek___en",
    path: "/en/search",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/zoek.vue")
  },
  {
    name: "index___nl",
    path: "/",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/index.vue")
  },
  {
    name: "slug___nl",
    path: "/:slug(.*)*",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/[...slug].vue")
  },
  {
    name: "blog___nl",
    path: "/blog",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/blog/index.vue")
  },
  {
    name: "blog___en",
    path: "/en/blog",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/blog/index.vue")
  },
  {
    name: "agenda___nl",
    path: "/agenda",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/agenda/index.vue")
  },
  {
    name: "agenda___en",
    path: "/en/calendar",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/agenda/index.vue")
  },
  {
    name: "nieuws___nl",
    path: "/nieuws",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/nieuws/index.vue")
  },
  {
    name: "nieuws___en",
    path: "/en/news",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/nieuws/index.vue")
  },
  {
    name: "agenda-archief___nl",
    path: "/agenda/archief",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/agenda/archief.vue")
  },
  {
    name: "agenda-archief___en",
    path: "/en/calendar/archive",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/agenda/archief.vue")
  },
  {
    name: "blog-slug___nl",
    path: "/blog/:slug(.*)*",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/blog/[...slug].vue")
  },
  {
    name: "blog-slug___en",
    path: "/en/blog/:blog()",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/blog/[...slug].vue")
  },
  {
    name: "collectie___nl",
    path: "/collectie",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/collectie/index.vue")
  },
  {
    name: "collectie___en",
    path: "/en/collection",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/collectie/index.vue")
  },
  {
    name: "agenda-slug___nl",
    path: "/agenda/:slug(.*)*",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/agenda/[...slug].vue")
  },
  {
    name: "agenda-slug___en",
    path: "/en/calendar/:calendar()",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/agenda/[...slug].vue")
  },
  {
    name: "nieuws-slug___nl",
    path: "/nieuws/:slug(.*)*",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/nieuws/[...slug].vue")
  },
  {
    name: "nieuws-slug___en",
    path: "/en/news/:news()",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/nieuws/[...slug].vue")
  },
  {
    name: "collectie-slug___nl",
    path: "/collectie/:slug(.*)*",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/collectie/[...slug].vue")
  },
  {
    name: "collectie-slug___en",
    path: "/en/collection/:collection()",
    component: () => import("/builds/allard-pierson/allard-pierson-frontend/pages/collectie/[...slug].vue")
  },
  {
    name: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5EMeta?.name,
    path: "/vrienden",
    component: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5E
  },
  {
    name: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5EMeta?.name,
    path: "/en/vrienden",
    component: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5E
  },
  {
    name: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5EMeta?.name,
    path: "/schenken",
    component: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5E
  },
  {
    name: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5EMeta?.name,
    path: "/en/schenken",
    component: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5E
  },
  {
    name: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5EMeta?.name,
    path: "/steun",
    component: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5E
  },
  {
    name: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5EMeta?.name,
    path: "/en/steun",
    component: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5E
  },
  {
    name: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5EMeta?.name,
    path: "/events/herkomstonderzoek-naar-illegale-handel-het-reconstrueren-van-netwerken-rond-archeologische-objecten",
    component: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5E
  },
  {
    name: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5EMeta?.name,
    path: "/en/events/herkomstonderzoek-naar-illegale-handel-het-reconstrueren-van-netwerken-rond-archeologische-objecten",
    component: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5E
  },
  {
    name: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5EMeta?.name,
    path: "/en/events/fellow-lecture-provenance-research-on-illicit-trade",
    component: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5E
  },
  {
    name: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5EMeta?.name,
    path: "/en/en/events/fellow-lecture-provenance-research-on-illicit-trade",
    component: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5E
  },
  {
    name: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5EMeta?.name,
    path: "/bezoek/allard-pierson-live/de-studio",
    component: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5E
  },
  {
    name: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5EMeta?.name,
    path: "/en/bezoek/allard-pierson-live/de-studio",
    component: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5E
  },
  {
    name: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5EMeta?.name,
    path: "/agenda/opening-amsterdam-eet",
    component: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5E
  },
  {
    name: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5EMeta?.name,
    path: "/en/agenda/opening-amsterdam-eet",
    component: component_45stub9CbQSU6dTWfv69I_whEt_45gafirEPA8QwNmTomdEnF5E
  }
]